<template>
  <div class="grey lighten-4">
    <v-container fluid fill-height class = "pb-0">
      <v-layout align-center justify-center >
        <v-flex >
          <v-card
            align="center"
            class="d-flex align-center mb-6 mx-auto"
            max-width="700"
            tile
            flat
            color="transparent"
          >
            <v-container fluid class="pa-6 pa-sm-16 pb-10">
              <h2 class="text-h5 text-sm-h4 black--text font-weight-medium mb-4">
                Tenemos para ti
              </h2>
              <p class="text-h6 black--text font-weight-light">
                Visita las diferentes marcas que se encuentran disponibles en
                nuestro espacio.
              </p>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fuild style="max-width: 1250px" class = "pb-16">
      <v-row>
        <v-col cols="6" sm="4" md="3">
          <v-card class="white mx-auto d-flex flex-column" height="100%" max-width="277" align="center" href="https://instagram.com/dekomundo_pe?utm_medium=copy_link" target="_blank">
            <v-img
              height="277"
              style="flex: none"
              alt="Deko Mundo — acabados decorativos"
              src="../assets/Deko Mundo2.webp"
            >
            </v-img>
            <v-card-title class="text-h6 black--text justify-center pt-5" style="word-break: normal; hyphens: none">
              DEKO MUNDO
            </v-card-title>
            <v-card-text class="font-weight-light black--text pb-7 flex-grow-1" style="min-height: 3.5em">
              Acabados decorativos para interiores y exteriores
            </v-card-text>
          </v-card>
        </v-col>
         
        <v-col cols="6" sm="4" md="3">
          <v-card class="white mx-auto d-flex flex-column" height="100%" max-width="277" align="center" href="https://www.larbis.net/" target="_blank">
            <v-img
              height="277"
              style="flex: none"
              alt="Larbis — calefacción radiante"
              src="../assets/Kronberg_BRELG167.webp"
            >
            </v-img>
            <v-card-title class="text-h6 black--text justify-center pt-5" style="word-break: normal; hyphens: none">
              LARBIS
            </v-card-title>
            <v-card-text class="font-weight-light black--text pb-7 flex-grow-1" style="min-height: 3.5em">
              Calefacción radiante de interiores y exteriores
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="6" sm="4" md="3">
          <v-card class="white mx-auto d-flex flex-column" height="100%" max-width="277" align="center" href="https://www.instagram.com/mueblum/" target="_blank">
            <v-img
              height="277"
              style="flex: none"
              alt="Mueblum — herrajes y accesorios para muebles"
              src="../assets/mueblum3.webp"
            >
            </v-img>
            <v-card-title class="text-h6 black--text justify-center pt-5" style="word-break: normal; hyphens: none">
              MUEBLUM
            </v-card-title>
            <v-card-text class="font-weight-light black--text pb-7 flex-grow-1" style="min-height: 3.5em">
              Soluciones en herrajes y accesorios para muebles
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="6" sm="4" md="3">
          <v-card class="white mx-auto d-flex flex-column" height="100%" max-width="277" align="center" href="https://www.rollux.pe/" target="_blank">
            <v-img
              height="277"
              style="flex: none"
              alt="Multilux — control solar y decoración de ventanas"
              src="../assets/Rollux.webp"
            >
            </v-img>
            <v-card-title class="text-h6 black--text justify-center pt-5" style="word-break: normal; hyphens: none">
              MULTILUX
            </v-card-title>
            <v-card-text class="font-weight-light black--text pb-7 flex-grow-1" style="min-height: 3.5em">
              Soluciones de control solar y decoración de ventanas 
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="6" sm="4" md="3">
          <v-card class="white mx-auto d-flex flex-column" height="100%" max-width="277" align="center" href="https://www.instagram.com/sheltercoffee.pe/" target="_blank">
            <v-img
              height="277"
              style="flex: none"
              alt="Shelter — café de especialidad y rooftop"
              src="../assets/shelter.webp"
            >
            </v-img>
            <v-card-title class="text-h6 black--text justify-center pt-5" style="word-break: normal; hyphens: none">
              Shelter
            </v-card-title>
            <v-card-text class="font-weight-light black--text pb-7 flex-grow-1" style="min-height: 3.5em">
              Café de especialidad y postres en un acogedor rooftop
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="6" sm="4" md="3">
          <v-card class="white mx-auto d-flex flex-column" height="100%" max-width="277" align="center" href="https://www.ventanasyestilos.com" target="_blank">
            <v-img
              height="277"
              style="flex: none"
              alt="Ventanas y Estilos — ventanería de PVC y protección solar"
              src="../assets/Ventanas y Estilos2.webp"
            >
            </v-img>
            <v-card-title class="text-h6 black--text justify-center pt-5" style="word-break: normal; hyphens: none">
              VYE
            </v-card-title>
            <v-card-text class="font-weight-light black--text pb-7 flex-grow-1" style="min-height: 3.5em">
              Ventanería hermética de PVC y sistemas de protección solar
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
export default {
  name: "TenemosParaTi",
};
</script>